export const getId = (prefix = "smb-") => {
  return `${prefix}-${Math.random().toString(36).substr(2, 9)}-${Math.random()
    .toString(36)
    .substr(2, 9)}`;
};
